export var SharePanelType;
(function (SharePanelType) {
    SharePanelType["COPY"] = "copy";
    SharePanelType["SMS"] = "sms";
    SharePanelType["WHATSAPP"] = "whatsapp";
    SharePanelType["FACEBOOK"] = "facebook";
    SharePanelType["TWITTER"] = "twitter";
    SharePanelType["NATIVE"] = "native";
})(SharePanelType || (SharePanelType = {}));
